<template>
    <div>
        <block v-if="loading"></block>
        <div>
            <v-row class="ma-2 mb-0" align="center">
                <v-col cols="12" md="4" v-if="UseRecurringTemplates">
                    <v-checkbox
                        v-model="filter.isrecurring"
                        label="Mostrar solo plantillas recurrentes"
                        color="primary"
                        dense
                        hide-details
                        :true-value="1"
                        :false-value="null"
                        @change="onRecurringFilterChanged"
                    ></v-checkbox>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="12" md="auto" v-if="filter.isrecurring">
                    <v-btn
                        color="success"
                        :disabled="selectedTemplates.length === 0"
                        @click="processSelectedTemplates"
                        :loading="processingTemplates"
                    >
                        <v-icon left>mdi-file-document-multiple</v-icon>
                        Procesar Seleccionadas ({{ selectedTemplates.length }})
                    </v-btn>
                </v-col>
            </v-row>
            <GeneralFilter 
                class="backgroundGlobal border-boxGlobal" 
                :search="filter" 
                :filterEndpoint="$API.invoices.getInvoicesFilteringNotBilled" 
                @emptyFilter="getAllInvoices" 
                @filtered="filterHandler"
                :enableDate="filter.isrecurring ? true : false"
            >
                <DxDataGrid 
                    ref="dataGrid"
                    :key="`grid-${filter.isrecurring}`"
                    class="isScrolledByGeneralFilter" 
                    :data-source="invoices" 
                    key-expr="ID_Invoice" 
                    @exporting="onExporting"
                    @selection-changed="onSelectionChanged"
                    :paging="{ enabled: false }" 
                    :scrolling="{useNative:true}" 
                    style="max-height: 600px;">
                    <DxExport :enabled="true" />
                    <DxSelection 
                        v-if="filter.isrecurring" 
                        mode="multiple" 
                        :select-all-mode="allMode"
                        show-check-boxes-mode="always"
                    />
                    <!--DxPaging :page-size="10" /-->
                    <DxColumn :width="80" cell-template="show-template" caption=""></DxColumn>
                    <DxColumn data-field="ID_Invoice" :width="200" caption="ID de plantilla"></DxColumn>
                    <DxColumn data-field="IsRecurring" caption="Tipo" :width="150" cell-template="type-template"></DxColumn>
                    <DxColumn data-field="TemplateName" :width="200" caption="Nombre"></DxColumn>
                    <DxColumn data-field="InvoiceDate" caption="Fecha de creación" :width="120"></DxColumn>
                    <DxColumn data-field="NextInvoiceDate" 
                        :width="200"
                        v-if="filter.isrecurring" 
                        caption="Fecha de próxima facturación" 
                        cell-template="next-date-template"></DxColumn>
                    <DxColumn data-field="PaymentFrequencyDays" 
                        v-if="filter.isrecurring" 
                        caption="Frecuencia (Dias)"
                        :width="120"></DxColumn>
                    <DxColumn data-field="ID_Customer" 
                        :width="200"
                        caption="ID de cliente o negocio"></DxColumn>
                    <DxColumn data-field="InvoiceName"
                        :width="300"
                        caption="Nombre Legal"></DxColumn>
                    <DxColumn data-field="InvoiceTotalPagarToShow" :width="200" caption="Total de la Factura"></DxColumn>
                    <template #show-template="{ data }">
                        <a href="#" class="mx-1" @click.prevent.stop="showInvoice = data; showModal = true">
                            <v-icon color="primary">mdi-eye</v-icon>
                        </a>
                    </template>
                    <template #next-date-template="{ data }">
                        {{ formatDateDDMMYYYY(data.data.NextInvoiceDate) }}
                    </template>
                    <template #type-template="{ data }">
                        {{ data.data.IsRecurring? 'COBRO RECURRENTE': 'PLANTILLA' }}
                    </template>
                </DxDataGrid>
            </GeneralFilter>
        </div>
        <!-- Show Invoice Modal -->
        <v-dialog v-model="showModal" max-width="75%">
            <v-card v-if="showInvoice">
                <invoice-details :hasDeleteBtn="true" :invoice="showInvoice.data" :key="showInvoice.data.ID_Invoice"
                    @close="hideModal" @billNow="billNow" @openFrequencyModal="openFrequencyModal"></invoice-details>

            </v-card>
        </v-dialog>

        <!-- Payment Frequency Modal -->
        <v-dialog v-model="showFrequencyModal" max-width="500px" persistent>
            <v-card>
                <v-card-title class="text-h5">
                    <v-icon left color="success">mdi-calendar-clock</v-icon>
                    Configurar Frecuencia de Facturación
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field
                                    v-model.number="frequencyForm.PaymentFrequencyDays"
                                    label="Frecuencia de pagos (días)"
                                    type="number"
                                    min="1"
                                    hint="Ingrese cada cuántos días se debe facturar"
                                    persistent-hint
                                    outlined
                                    @input="calculateNextInvoiceDate"
                                >
                                    <template v-slot:prepend-inner>
                                        <v-icon>mdi-calendar-range</v-icon>
                                    </template>
                                </v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field
                                    v-model="frequencyForm.NextInvoiceDateDisplay"
                                    label="Próxima fecha de facturación"
                                    prepend-inner-icon="mdi-calendar-check"
                                    type="date"
                                    outlined
                                    hint="Puede editar la fecha de la próxima facturación o se calcula automáticamente"
                                    persistent-hint
                                >
                                </v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                    <v-alert type="info" dense text class="mt-2">
                        <small>
                            <b>Plantilla:</b> {{ selectedTemplate ? selectedTemplate.TemplateName || selectedTemplate.ID_Invoice : '' }}<br>
                            <b>Fecha base:</b> {{ selectedTemplate ? selectedTemplate.InvoiceDate : '' }}
                        </small>
                    </v-alert>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="grey darken-1" text @click="closeFrequencyModal">
                        Cancelar
                    </v-btn>
                    <v-btn 
                        color="success" 
                        @click="saveFrequency" 
                        :disabled="!isFrequencyFormValid" 
                        :loading="savingFrequency"
                    >
                        <v-icon left>mdi-content-save</v-icon>
                        Guardar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Alerts Component -->
        <alerts
            v-if="alert.show"
            v-on:close_alert="closeAlert"
            v-on:accept_alert="acceptAlert"
            :properties="alert"
        >
        </alerts>
    </div>
</template>

<script>
import { DxDataGrid, DxColumn, DxExport, DxSelection } from 'devextreme-vue/data-grid';
import GeneralFilter from '../../components/GeneralFilterV2.vue';
import { printToExcel } from "@/helpers/printToexcel";

import InvoiceDetails from "./InvoiceDetails";
import Block from "@/components/Block";
import Alerts from "@/components/Alerts";
import { numberWithCommas } from '../../helpers/money';

export default {
    name: "TemplateBill",
    components: { DxColumn, DxDataGrid, GeneralFilter, InvoiceDetails, Block, DxExport, Alerts, DxSelection },
    data() {
        return {
            loading: false,
            form: {},
            showModal: false,
            showFrequencyModal: false,
            savingFrequency: false,
            filter: {
                //pay: true,
                ID_Branch: null,
                ID_Business: null,
                status: 0,
                istemplate: 1,
                isquote: 0,
                isrecurring: null
            },
            invoices: null,
            showInvoice: null,
            selectedTemplate: null,
            frequencyForm: {
                PaymentFrequencyDays: null,
                NextInvoiceDate: null,
                NextInvoiceDateDisplay: null
            },
            alert: {
                type: "success",
                show: false,
                header: "",
                body: "",
            },
            selectedTemplates: [],
            allMode: 'allPages',
            processingTemplates: false,
            UseRecurringTemplates: JSON.parse(localStorage.getItem("user")).userecurringtemplates || 0,
        }
    },
    computed: {
        isFrequencyFormValid() {
            return this.frequencyForm.PaymentFrequencyDays > 0;
        },
        calculatedNextInvoiceDate() {
            if (!this.selectedTemplate || !this.frequencyForm.PaymentFrequencyDays || this.frequencyForm.PaymentFrequencyDays < 1) {
                return 'Ingrese la frecuencia de pagos';
            }
            
            // Parsear la fecha de la plantilla (formato dd/mm/yyyy)
            const invoiceDateStr = this.selectedTemplate.InvoiceDate;
            if (!invoiceDateStr) {
                return 'Fecha de plantilla no disponible';
            }
            
            // Convertir fecha de dd/mm/yyyy a objeto Date
            const parts = invoiceDateStr.split('/');
            if (parts.length !== 3) {
                return 'Formato de fecha inválido';
            }
            
            const day = parseInt(parts[0], 10);
            const month = parseInt(parts[1], 10) - 1; // Los meses en JS son 0-indexed
            const year = parseInt(parts[2], 10);
            
            const baseDate = new Date(year, month, day);
            
            // Sumar los días de frecuencia
            const nextDate = new Date(baseDate);
            nextDate.setDate(baseDate.getDate() + parseInt(this.frequencyForm.PaymentFrequencyDays));
            
            // Formatear para mostrar en UI (dd/mm/yyyy)
            const yyyy = nextDate.getFullYear();
            const mm = String(nextDate.getMonth() + 1).padStart(2, '0');
            const dd = String(nextDate.getDate()).padStart(2, '0');
            
            // Retornar solo el valor para mostrar, sin side effects
            return `${dd}/${mm}/${yyyy}`;
        }
    },
    watch: {
        // Actualizar NextInvoiceDate para el backend cuando cambie la frecuencia o la plantilla
        'frequencyForm.PaymentFrequencyDays'() {
            this.updateNextInvoiceDate();
        },
        'selectedTemplate'() {
            this.updateNextInvoiceDate();
        },
        // Actualizar NextInvoiceDate cuando el usuario edite manualmente la fecha
        'frequencyForm.NextInvoiceDateDisplay'(newValue) {
            if (newValue) {
                this.frequencyForm.NextInvoiceDate = newValue;
            }
        }
    },
    mounted() {
        this.filter.ID_Branch = JSON.parse(localStorage.getItem("user")).branch;
        this.filter.ID_Business = JSON.parse(localStorage.getItem("user")).businessid;

        this.getAllInvoices()
    },
    methods: {
        formatInvoiceFields() {
                // const dictionary = {
                //     '00': "Prueba",
                //     '01': "Producción"
                // };
                const { Currency } = JSON.parse(localStorage.getItem('branch'));
                for(const index in this.invoices) {
                    // const { IdentificacionHorEmi, InvoiceType, SystemDateInsert, IdentificacionTipoDteDesc } = this.invoices[ index ];

                    // this.invoices[index].AmbienteToShow = dictionary[this.invoices[index].IdentificacionAmbiente];
                    this.invoices[index].InvoiceTotalPagarToShow = `${Currency}${numberWithCommas(this.invoices[index].InvoiceTotalPagar)}`;

                    // if( InvoiceType === 'TCKS' ) {
                    //     this.invoices[ index ].HorEmi = this.formatDateToHour(SystemDateInsert);
                    //     this.invoices[ index ].TipoDocumento = "TICKET";
                    // } else {
                    //     if( IdentificacionTipoDteDesc != null ) {
                    //         this.invoices[ index ].TipoDocumento = IdentificacionTipoDteDesc;
                    //     } else {
                    //         this.invoices[ index ].TipoDocumento = "";
                    //     }
                    //     if( IdentificacionHorEmi != null ) {
                    //         this.invoices[ index ].HorEmi = IdentificacionHorEmi;
                    //     } else { 
                    //         this.invoices[ index ].HorEmi = "";
                    //     }
                    // }
                    // {{ data.data.IdentificacionHorEmi != null ? data.data.IdentificacionHorEmi : "" }}
                    //     {{ data.data.InvoiceType === 'TCKS' ? formatDateToHour(data.data.SystemDateInsert) : "" }}
                }
            },
        filterHandler(response){
            this.invoices = [ ...response ];
            this.formatInvoiceFields();
        },
        onRecurringFilterChanged() {
            // Limpiar selección cuando cambia el filtro recurrente
            this.selectedTemplates = [];
            this.getAllInvoices();
        },
        getAllInvoices() {
            this.loading = true
            this.$API.invoices.getInvoicesPOSHistoryNotBilled(this.filter)
                .then(response => {
                    this.loading = false
                    this.invoices = [ ...response ];
                    this.formatInvoiceFields();
                })
        },
        hideModal() {
            this.showModal = false;
            this.showInvoice = null;
            this.getAllInvoices();
        },
        billNow() {
            this.hideModal();
            this.$emit('generateInvoice')
        },
        onExporting(e) {
            printToExcel(e, "Lista de plantillas")
        },
        openFrequencyModal(invoice) {
            this.selectedTemplate = invoice;
            this.frequencyForm.PaymentFrequencyDays = invoice.PaymentFrequencyDays || null;
            // Calcular la fecha inicial para mostrar
            this.updateNextInvoiceDate();
            this.showFrequencyModal = true;
        },
        closeFrequencyModal() {
            this.showFrequencyModal = false;
            this.selectedTemplate = null;
            this.frequencyForm = {
                PaymentFrequencyDays: null,
                NextInvoiceDate: null,
                NextInvoiceDateDisplay: null
            };
        },
        calculateNextInvoiceDate() {
            // El cálculo se realiza automáticamente en el computed property
            // Este método se dispara para forzar la reactividad
            this.updateNextInvoiceDate();
        },
        updateNextInvoiceDate() {
            if (!this.selectedTemplate || !this.frequencyForm.PaymentFrequencyDays || this.frequencyForm.PaymentFrequencyDays < 1) {
                this.frequencyForm.NextInvoiceDate = null;
                this.frequencyForm.NextInvoiceDateDisplay = null;
                return;
            }
            let nextDate;
            if (this.selectedTemplate.NextInvoiceDate) {
                const rawDate = this.selectedTemplate.NextInvoiceDate;

                if (rawDate instanceof Date) {
                    nextDate = new Date(rawDate.getFullYear(), rawDate.getMonth(), rawDate.getDate());
                } 
                else if (typeof rawDate === 'string') {
                    const [year, month, day] = rawDate.split('-').map(Number);
                    nextDate = new Date(year, month - 1, day);
                }
            } 
            else if (this.selectedTemplate.InvoiceDate) {
                const invoiceDateStr = this.selectedTemplate.InvoiceDate;
                const parts = invoiceDateStr.split('/');
                if (parts.length === 3) {
                    const day = parseInt(parts[0], 10);
                    const month = parseInt(parts[1], 10) - 1;
                    const year = parseInt(parts[2], 10);
                    nextDate = new Date(year, month, day);
                }
            }
            if (!nextDate) {
                this.frequencyForm.NextInvoiceDate = null;
                this.frequencyForm.NextInvoiceDateDisplay = null;
                return;
            }
            nextDate.setDate(nextDate.getDate() + parseInt(this.frequencyForm.PaymentFrequencyDays, 10));
            const yyyy = nextDate.getFullYear();
            const mm = String(nextDate.getMonth() + 1).padStart(2, '0');
            const dd = String(nextDate.getDate()).padStart(2, '0');
            this.frequencyForm.NextInvoiceDate = `${yyyy}-${mm}-${dd}`;
            this.frequencyForm.NextInvoiceDateDisplay = `${yyyy}-${mm}-${dd}`;
        },
        async saveFrequency() {
            if (!this.isFrequencyFormValid || !this.selectedTemplate) {
                return;
            }

            this.savingFrequency = true;

            try {
                await this.$API.invoices.updateTemplatePaymentFrequency(
                    this.selectedTemplate.ID_Invoice,
                    this.frequencyForm
                );

                // Actualizar el invoice en showInvoice si está abierto
                if (this.showInvoice && this.showInvoice.data.ID_Invoice === this.selectedTemplate.ID_Invoice) {
                    this.showInvoice.data.PaymentFrequencyDays = this.frequencyForm.PaymentFrequencyDays;
                    this.showInvoice.data.NextInvoiceDate = this.frequencyForm.NextInvoiceDate;
                    this.showInvoice.data.IsRecurring = this.frequencyForm.PaymentFrequencyDays > 0 ? 1 : 0;
                }

                this.showAlert(
                    'success',
                    '¡Éxito!',
                    'Frecuencia de facturación actualizada correctamente'
                );

                this.closeFrequencyModal();
                this.getAllInvoices();

            } catch (error) {
                console.error('Error al actualizar frecuencia:', error);
                this.showAlert(
                    'danger',
                    'Error',
                    error.response?.data?.message || 'No se pudo actualizar la frecuencia de facturación'
                );
            } finally {
                this.savingFrequency = false;
            }
        },
        showAlert(type, header, body, options = null) {
            type = type == null ? "danger" : type;
            this.alert.type = type;
            this.alert.header = header;
            this.alert.body = body;
            this.alert.show = true;
            this.alert.options = options != null ? options : null;
        },
        closeAlert() {
            this.alert.show = false;
        },
        acceptAlert() {
            this.closeAlert();
            if (this.alert.options && this.alert.options.callback) {
                this.alert.options.callback();
            }
        },
        onSelectionChanged(e) {
            // Actualizar el array de plantillas seleccionadas
            this.selectedTemplates = e.selectedRowKeys;
        },
        async processSelectedTemplates() {
            if (this.selectedTemplates.length === 0) {
                this.showAlert(
                    'warning',
                    'Sin selección',
                    'Debe seleccionar al menos una plantilla para procesar'
                );
                return;
            }

            this.processingTemplates = true;

            try {
                const response = await this.$API.invoices.processSelectedRecurringTemplates(
                    this.selectedTemplates
                );

                console.log('===== RESPUESTA RECIBIDA EN FRONTEND =====');
                console.log('response completo:', response);
                console.log('typeof response:', typeof response);
                console.log('response.data:', response.data);
                console.log('response.message:', response.message);
                console.log('==========================================');

                // El API service ya desempaqueta, así que response ES el objeto { message, data }
                const processedCount = response.data?.totalProcessed || 0;
                const errorCount = response.data?.totalErrors || 0;

                console.log(`Procesadas: ${processedCount}, Errores: ${errorCount}`);

                // Verificar si hubo errores
                if (errorCount > 0 && response.data?.errors) {
                    const errorMessages = response.data.errors.map(err => 
                        `- ${err.templateName || err.templateId}: ${err.error}`
                    ).join('\n');

                    this.showAlert(
                        'warning',
                        'Procesamiento Completado con Errores',
                        `Se procesaron ${processedCount} de ${response.data.totalReceived} plantillas correctamente.\n\nErrores:\n${errorMessages}`
                    );
                } else if (processedCount > 0) {
                    this.showAlert(
                        'success',
                        '¡Éxito!',
                        `Se procesaron ${processedCount} plantillas correctamente y se crearon las facturas.`
                    );
                } else {
                    this.showAlert(
                        'success',
                        response.message || 'Procesamiento completado'
                    );
                }

                // Limpiar selección
                if (this.$refs.dataGrid && this.$refs.dataGrid.instance) {
                    this.$refs.dataGrid.instance.clearSelection();
                }

                // Recargar la grid para ver las plantillas actualizadas
                this.getAllInvoices();

            } catch (error) {
                console.error('===== ERROR AL PROCESAR PLANTILLAS =====');
                console.error('Error completo:', error);
                console.error('error.response:', error.response);
                console.error('error.response?.status:', error.response?.status);
                console.error('error.response?.data:', error.response?.data);
                console.error('error.message:', error.message);
                console.error('========================================');
                
                this.showAlert(
                    'danger',
                    'Error',
                    error.response?.data?.message || 'No se pudieron procesar las plantillas seleccionadas'
                );
            } finally {
                this.processingTemplates = false;
            }
        },
        formatDateDDMMYYYY(dateString) {
            if (!dateString) return '';
            
            // Si viene en formato yyyy-mm-dd, convertir a dd/mm/yyyy
            if (dateString.includes('-')) {
                const [yyyy, mm, dd] = dateString.split('-');
                return `${dd}/${mm}/${yyyy}`;
            }
            
            // Si ya está en formato dd/mm/yyyy, devolverlo tal cual
            if (dateString.includes('/')) {
                return dateString;
            }
            
            return dateString;
        }
    }
}
</script>

<style scoped>
.btn-add {
    background-color: #00A178 !important;
    color: white;
}
</style>